import axios from "../../axios";

export const GetInterviewSheet = async (InterviewUID) => {
	return axios.post("/api/Interview/GetInterviewSheet", {
		InterviewUID,
	});
};

export const GetConclusionStatus = async (InterviewUID) => {
	return axios.post("/api/Interview/GetInterviewConclusionStatus", {
		InterviewUID,
	});
};

export const SubmitInterviewSheet = async (
	InterviewUID,
	interviewConclusion,
	interviewRemark,
	interviewAssessmentRemarks
) => {
	return axios.post("/api/Interview/SubmitInterviewSheet", {
		InterviewUID,
		interviewConclusion,
		interviewRemark,
		interviewAssessmentRemarks,
	});
};

export const GetInterviewDetails = async (InterviewUID) => {
	return axios.post("/api/Interview/GetInterviewDetails", {
		InterviewUID,
	});
};

export const ScheduleInterview = async (payload) => {
	return await axios.post("/api/Interview/ScheduleInterview", payload);
};


// Harshada Bhavsar (15/09/2025)
export const GetInterviewResume = async (resumeFileName, interviewUID) => {
  return await axios.post(
    `/api/Interview/GetInterviewResume/${resumeFileName}`,
    { interviewUID },
    {
      responseType: "blob", 
    }
  );
};
